import {Component, ViewChild, ViewContainerRef, ComponentResolver} from "@angular/core";

@Component({
  selector: "core-componentresolver-child",
  template: `<p>{{text}}</p>`
})
class ChildComponent {
  text = "";
}

@Component({
  selector: 'core-componentresolver',
  template: `
  <usecase-container title="ComponentResolver" src="core/componentresolver">
    <usecase-content>
      <div #container></div>
    </usecase-content>
  </usecase-container>
  `,
  directives: [
    ChildComponent
  ]
})
export class ComponentResolverComponent {
  @ViewChild("container", { read: ViewContainerRef }) container: ViewContainerRef;

  constructor(private componentResolver: ComponentResolver) { }

  ngAfterViewInit() {
    // load 3 components
    ["Apple", "Orange", "Grape"].forEach(text => {
      this.componentResolver.resolveComponent(ChildComponent).then(factory => {
        let component = this.container.createComponent<ChildComponent>(factory);
        component.instance.text = text;
      });
    })
  }
}



/** WEBPACK FOOTER **
 ** ./script/core/componentresolver/component.ts
 **/